import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const boreholeApi = createApi({
    reducerPath: "core/borehole",
    baseQuery: axiosBaseQuery,
    tagTypes: ["boreholeList"],
    endpoints: (builder) => ({
        boreholeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['boreholeList'],
            query: (query = '') => ({
                url: "/core/borehole" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        boreholeCreate: builder.mutation({
            invalidatesTags: ['boreholeList'],
            query: (data) => ({
                url: `/core/borehole`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        boreholeUpdate: builder.mutation({
            invalidatesTags: ['boreholeList'],
            query: (data) => ({
                url: `/core/borehole/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        boreholeDelete: builder.mutation({
            invalidatesTags: ['boreholeList'],
            query: (id) => ({ url: "/core/borehole/" + id, method: "DELETE" })
        }),
    })
})

export const { useBoreholeFindAllQuery, useBoreholeCreateMutation, useBoreholeUpdateMutation, useBoreholeDeleteMutation } = boreholeApi;
export { boreholeApi };
